import { BRANCH_NOT_FOUND } from '../constants';

const makeBranchItem = branch => {
  if (branch === BRANCH_NOT_FOUND)
    return {
      value: BRANCH_NOT_FOUND,
      label: 'branch.branchNotFound',
    };

  return branch
    ? {
        value: branch,
        label: `${branch.street}, ${branch.zip} ${branch.city}`,
      }
    : null;
};

export default makeBranchItem;
